import { _ } from "../../../polyglot/polyglot.js";
import AbstractWizardStep from "../../AbstractWizardStep.js";
import RadioGroupWidget from "../../../widgets/RadioGroupWidget/RadioGroupWidget.js";

/**
 * Wizard step asking the user to select importing all or new data
 * since the last import.
 */
export default class DataLoadingOptionStep extends AbstractWizardStep {
	getRenderable() {
		return (html) => {
			const partialImportSelected =
				this._context.xeroPartialImport ?? true;
			const elements = [
				{
					name: "partialData",
					label: _("Import only new data"),
					selected: partialImportSelected,
					dataTestName: "import-new-data",
					value: true,
				},
				{
					name: "allData",
					label: _("Import all data (re­places ex­ist­ing data)"),
					selected: !partialImportSelected,
					dataTestName: "import-all-data",
					value: false,
				},
			];
			this._radio = new RadioGroupWidget({ elements });

			html.render(this._radio);
		};
	}

	_doSubmit(...rest) {
		this._context.xeroPartialImport = this._radio.getValue();
		super._doSubmit(...rest);
	}

	_isCompleted() {
		return true;
	}
}
